import type { IRegion, IRegionCountry } from '@/pages/intelligence/types/common';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';

const handleCountriesData2Standard = (data: any[]): IRegionCountry[] => {
  if (!Array.isArray(data)) return [];
  return data.map((item) => {
    const { abbre, name } = item ?? {};
    return {
      country_code: abbre ?? '',
      country_name_en: name ?? '',
      country_name_ch: name ?? '',
    };
  });
};

export const handleRegionsCountriesData2Standard = (data: any[]): IRegion[] => {
  if (!Array.isArray(data)) return [];
  return data.map((item) => {
    const { continent, subcontinent, country_set: countrySet } = item ?? {};
    const countries: IRegionCountry[] = handleCountriesData2Standard(countrySet);
    return {
      area_code: continent ?? '',
      area_name_en: subcontinent ?? '',
      area_name_ch: subcontinent ?? '',
      country_set: countries ?? [],
    };
  });
};

export const getUpperCaseRegionsValues = (data: string[]): string[] => {
  if (!Array.isArray(data)) return [];
  return data.map((item) => item?.toUpperCase());
};

// 特殊处理一下筛选器的时间没有年时初始闪动的继承问题
export const getCustomExtend = (filterExtend: any, hasYear: boolean, hasDayAndWeek: boolean) => {
  // console.log('getCustomExtend-filterExtend', filterExtend);
  // console.log('getCustomExtend-hasYear', hasYear);
  // console.log('getCustomExtend-hasDayAndWeek', hasDayAndWeek);

  const timeExtend = filterExtend?.[filterKeyMap.RANGE_TIME];
  const date = timeExtend?.value?.[0];
  if (
    !date ||
    (!hasYear && timeExtend?.type === 'year') ||
    (!hasDayAndWeek && (timeExtend?.type === 'date' || timeExtend?.type === 'week'))
  ) {
    return {
      filter: {
        ...filterExtend,
        [filterKeyMap.RANGE_TIME]: {
          end_date: '',
          type: 'month',
          start_date: '',
        },
      },
      params: {
        granularity: 'monthly',
        date_type: 'month',
        filterType: 'month',
        start_date: '',
        end_date: '',
      },
    };
  }
  return { filter: filterExtend, params: {} };
};
